// Varga catalog for the Divisional Charts Studio — data-only module split
// from the studio component at the G03 500-line ceiling. Classical varga
// definitions (D1..D60): fixed Parashari vocabulary, never model prose.

export interface VargaDef {
  id: string;
  name: string;
  sanskrit: string;
  symbol: string;
  division: string;
  domain: string;
  governs: string[];
  keyGrahas: string;
  specialCheck: string;
  link: string;
}

export const VARGA_CHARTS: VargaDef[] = [
  {
    id: "d1",
    name: "D-1 Rashi Chart",
    sanskrit: "जन्म लग्न चक्र",
    symbol: "🌟",
    division: "Full Sign (30°00')",
    domain: "Physical existence, core personality, overall vitality",
    governs: [
      "Lifelong physical health & temperament",
      "Primary house lords & planet aspects",
      "Baseline framework of all dasha periods",
    ],
    keyGrahas: "Lagna Lord (Ascendant Lord)",
    specialCheck:
      "Strength of Lagna and Lagnesha sets the foundation for whether other yogas can bear fruit.",
    link: "/free-kundali/",
  },
  {
    id: "d9",
    name: "D-9 Navamsha",
    sanskrit: "नवांश चक्र",
    symbol: "💍",
    division: "1/9th Division (3°20')",
    domain: "Marriage, spouse traits, inner dharma & post-30 destiny",
    governs: [
      "Spouse's temperament and marital compatibility",
      "Dharmic purpose and hidden soul strength",
      "Planetary potency (Vargottama / Pushkar Navamsha)",
    ],
    keyGrahas: "Venus (Shukra), Jupiter (Guru), 7th Lord",
    specialCheck:
      "A planet exalted in D1 but debilitated in D9 loses its real-world delivery power; check Vargottama status.",
    link: "/navamsa-chart/",
  },
  {
    id: "d10",
    name: "D-10 Dashamsha",
    sanskrit: "दशमांश चक्र",
    symbol: "💼",
    division: "1/10th Division (3°00')",
    domain: "Career trajectory, leadership, public fame & livelihood",
    governs: [
      "Professional success, executive promotions & business growth",
      "Government standing, honors, and authority",
      "Long-term legacy and karma in society",
    ],
    keyGrahas: "Sun (Surya), Saturn (Shani), 10th Lord",
    specialCheck:
      "Examines the 10th house of profession at 10x microscopic resolution to pinpoint ideal career domains.",
    link: "/dasamsa/",
  },
  {
    id: "d7",
    name: "D-7 Saptamsha",
    sanskrit: "सप्तांश चक्र",
    symbol: "👶",
    division: "1/7th Division (4°17')",
    domain: "Progeny, children's prosperity, and creative output",
    governs: [
      "Childbirth timing and progeny blessings",
      "Health and accomplishments of children",
      "Partnership creativity and grandfather karma",
    ],
    keyGrahas: "Jupiter (Putrakaraka), 5th Lord",
    specialCheck:
      "Analyzes 5th house of progeny; clarifies fertility and child well-being when D1 shows mixed indicators.",
    link: "/saptamsa/",
  },
  {
    id: "d4",
    name: "D-4 Chaturthamsha",
    sanskrit: "चतुर्थांश चक्र",
    symbol: "🏠",
    division: "1/4th Division (7°30')",
    domain: "Real estate, fixed assets, mother's happiness & fortune",
    governs: [
      "Acquisition of land, homes, and luxury vehicles",
      "Domestic contentment and residence stability",
      "Inheritance of physical property",
    ],
    keyGrahas: "Mars (Bhoomi Karaka), Moon (Matri Karaka), 4th Lord",
    specialCheck:
      "Confirms whether real estate investments or property litigation will resolve favorably.",
    link: "/chaturthamsa/",
  },
  {
    id: "d12",
    name: "D-12 Dwadashamsha",
    sanskrit: "द्वादशांश चक्र",
    symbol: "🪷",
    division: "1/12th Division (2°30')",
    domain: "Parents, ancestral lineage, and inherited genetic karma",
    governs: [
      "Father and mother's longevity and health",
      "Ancestral heritage and past-life merits/debts",
      "Paternal and maternal lineage blessings",
    ],
    keyGrahas: "Sun (Father), Moon (Mother), 9th & 4th Lords",
    specialCheck:
      "Identifies whether ancestral Pitra afflictions exist in the maternal or paternal line.",
    link: "/dwadasamsa/",
  },
];
